import "./cadastro-participantes-vila-pinto.b081ef1c.js";
import "./firebase-init-vp.9a246ac5.js";
import "./firebase-init-coadesc.a6d910f2.js";
import "./firebase-init-pc.49251f90.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree555"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree555"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dCqD9", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");

var $hPtJY = parcelRequire("hPtJY");
window.Buffer = (0, $6ZWSX.Buffer);
window.process = (0, (/*@__PURE__*/$parcel$interopDefault($hPtJY)));

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRequire("dCqD9");

var $bhHFP = parcelRequire("bhHFP");

var $dbOS5 = parcelRequire("dbOS5");

var $hEplm = parcelRequire("hEplm");

var $ilpIi = parcelRequire("ilpIi");
document.addEventListener("DOMContentLoaded", ()=>{
    "use strict";
    const HEADER_SCROLL_OFFSET = 96;
    const INITIAL_MAP_VIEW = {
        lat: -30.055,
        lng: -51.165,
        zoom: 11
    };
    const VALID_CRGR_IDS = [
        "vila-pinto",
        "cooadesc",
        "padre-cacique"
    ];
    const FIREBASE_DATABASES = [
        {
            key: "vila-pinto",
            label: "Vila Pinto",
            db: (0, $bhHFP.db)
        },
        {
            key: "cooadesc",
            label: "COOADESC",
            db: (0, $dbOS5.db)
        },
        {
            key: "padre-cacique",
            label: "Padre Cacique",
            db: (0, $hEplm.db)
        }
    ];
    const $ = (selector, scope = document)=>scope.querySelector(selector);
    const $$ = (selector, scope = document)=>Array.from(scope.querySelectorAll(selector));
    const STATE = {
        crgrs: [],
        metrics: {
            crgrs: 0,
            users: 0,
            approvals: 0,
            coletas: 0,
            alerts: 0
        }
    };
    const FALLBACK_CRGRS = [
        {
            id: "vilapinto",
            code: "vilapinto",
            territoryId: "vila-pinto",
            name: "CRGR Vila Pinto",
            territoryLabel: "CRGR Vila Pinto",
            lat: -30.048729170292532,
            lng: -51.15652604283108,
            address: "Avenida Joaquim Porto Vilanova, 143 \u2022 Bom Jesus \u2022 Porto Alegre/RS",
            page: "vila-pinto.html",
            active: true,
            color: "#62B32F"
        },
        {
            id: "cooadesc",
            code: "cooadesc",
            territoryId: "cooadesc",
            name: "CRGR Cooadesc",
            territoryLabel: "CRGR Cooadesc",
            lat: -30.003,
            lng: -51.206,
            address: "Rua Seis (Vila Esperan\xe7a), 113 \u2022 Farrapos \u2022 Porto Alegre/RS",
            page: "cooadesc.html",
            active: true,
            color: "#2FA8D8"
        },
        {
            id: "padrecacique",
            code: "padrecacique",
            territoryId: "padre-cacique",
            name: "CRGR Padre Cacique",
            territoryLabel: "CRGR Padre Cacique",
            lat: -30.140122365657504,
            lng: -51.1268772051727,
            address: "Estrada do Rinc\xe3o, 6781 \u2022 Bel\xe9m Velho \u2022 Porto Alegre/RS",
            page: "padre-cacique.html",
            active: true,
            color: "#ef6b22"
        }
    ];
    let map = null;
    let mapMarkers = [];
    let publicIndicatorsUnsubscribers = [];
    function byId(id) {
        return document.getElementById(id);
    }
    function setText(id, value) {
        const el = byId(id);
        if (el) el.textContent = String(value ?? 0);
    }
    function escapeHtml(value = "") {
        return String(value).replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll('"', "&quot;").replaceAll("'", "&#039;");
    }
    function toNumber(value) {
        if (value === null || value === undefined || value === "") return 0;
        const parsed = Number(String(value).trim().replace(/\s/g, "").replace(/kg|kgs|quilo|quilos|litros?|r\$/gi, "").replace(/\./g, "").replace(",", ".").replace(/[^\d.-]/g, ""));
        return Number.isFinite(parsed) ? parsed : 0;
    }
    function toNumberOrNull(value) {
        if (value === null || value === undefined || value === "") return null;
        const number = Number(value);
        return Number.isFinite(number) ? number : null;
    }
    function isReducedMotion() {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    function safeScrollTo(target, offset = HEADER_SCROLL_OFFSET) {
        if (!target) return;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({
            top: top,
            behavior: "smooth"
        });
    }
    function canonicalTerritoryId(value) {
        const raw = String(value || "").trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll("_", "-").replace(/\s+/g, "-");
        if (!raw) return "";
        if (raw === "vp" || raw === "vilapinto" || raw === "vila-pinto" || raw === "crgr-vila-pinto" || raw === "crgr-vilapinto") return "vila-pinto";
        if (raw === "coadesc" || raw === "cooadesc" || raw === "crgr-coadesc" || raw === "crgr-cooadesc") return "cooadesc";
        if (raw === "pc" || raw === "padre" || raw === "padrecacique" || raw === "padre-cacique" || raw === "crgr-padre-cacique") return "padre-cacique";
        return raw;
    }
    function isValidCrgrId(value) {
        return VALID_CRGR_IDS.includes(canonicalTerritoryId(value));
    }
    function getValidCrgrs(items = []) {
        const mapByTerritory = new Map();
        items.forEach((item)=>{
            const territoryId = canonicalTerritoryId(item.territoryId || item.code || item.id);
            if (!isValidCrgrId(territoryId)) return;
            if (!Number.isFinite(item.lat)) return;
            if (!Number.isFinite(item.lng)) return;
            if (!mapByTerritory.has(territoryId)) mapByTerritory.set(territoryId, {
                ...item,
                territoryId: territoryId
            });
        });
        return Array.from(mapByTerritory.values());
    }
    function initCursorGlow() {
        const cursorGlow = byId("cursorGlow");
        if (!cursorGlow || isReducedMotion()) return;
        let rafId = null;
        let mouseX = -9999;
        let mouseY = -9999;
        function updateGlowPosition() {
            cursorGlow.style.setProperty("--mx", String(mouseX));
            cursorGlow.style.setProperty("--my", String(mouseY));
            rafId = null;
        }
        window.addEventListener("mousemove", (event)=>{
            mouseX = event.clientX;
            mouseY = event.clientY;
            cursorGlow.style.opacity = "1";
            if (!rafId) rafId = requestAnimationFrame(updateGlowPosition);
        });
        window.addEventListener("mouseleave", ()=>{
            cursorGlow.style.opacity = "0";
        });
    }
    function initReveal() {
        const revealEls = $$("[data-reveal]");
        if (!revealEls.length) return;
        if (!("IntersectionObserver" in window) || isReducedMotion()) {
            revealEls.forEach((el)=>el.classList.add("in"));
            return;
        }
        const observer = new IntersectionObserver((entries, obs)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                entry.target.classList.add("in");
                obs.unobserve(entry.target);
            });
        }, {
            threshold: 0.12,
            rootMargin: "0px 0px -8% 0px"
        });
        revealEls.forEach((el)=>observer.observe(el));
    }
    function initAnchorScroll() {
        $$('a[href^="#"]').forEach((el)=>{
            el.addEventListener("click", (event)=>{
                const href = el.getAttribute("href");
                if (!href || href === "#") return;
                const target = document.querySelector(href);
                if (!target) return;
                event.preventDefault();
                safeScrollTo(target);
                history.replaceState(null, "", href);
            });
        });
    }
    function initFaq() {
        const items = $$("details.faq-item");
        items.forEach((detail)=>{
            detail.addEventListener("toggle", ()=>{
                if (!detail.open) return;
                items.forEach((other)=>{
                    if (other !== detail) other.open = false;
                });
            });
        });
    }
    function initHeroCarousel() {
        const root = byId("heroCarousel");
        if (!root) return;
        const slides = $$(".hero-slide", root);
        const dots = $$(".carousel-dot", root);
        const prevBtn = byId("carouselPrev");
        const nextBtn = byId("carouselNext");
        if (!slides.length) return;
        let currentIndex = 0;
        let intervalId = null;
        const delay = 4500;
        function render() {
            slides.forEach((slide, index)=>{
                slide.classList.toggle("is-active", index === currentIndex);
            });
            dots.forEach((dot, index)=>{
                dot.classList.toggle("is-active", index === currentIndex);
            });
        }
        function goTo(index) {
            if (index < 0) currentIndex = slides.length - 1;
            else if (index >= slides.length) currentIndex = 0;
            else currentIndex = index;
            render();
        }
        function next() {
            goTo(currentIndex + 1);
        }
        function prev() {
            goTo(currentIndex - 1);
        }
        function stopAuto() {
            if (!intervalId) return;
            clearInterval(intervalId);
            intervalId = null;
        }
        function startAuto() {
            stopAuto();
            if (isReducedMotion()) return;
            intervalId = setInterval(next, delay);
        }
        prevBtn?.addEventListener("click", ()=>{
            prev();
            startAuto();
        });
        nextBtn?.addEventListener("click", ()=>{
            next();
            startAuto();
        });
        dots.forEach((dot)=>{
            dot.addEventListener("click", ()=>{
                goTo(Number(dot.dataset.slide || 0));
                startAuto();
            });
        });
        root.addEventListener("mouseenter", stopAuto);
        root.addEventListener("mouseleave", startAuto);
        render();
        startAuto();
    }
    function getCrgrPage(name = "", id = "", territoryId = "") {
        const base = `${name} ${id} ${territoryId}`.toLowerCase();
        if (base.includes("vila pinto") || base.includes("vilapinto") || base.includes("crgr_vila_pinto") || base.includes("vila-pinto")) return "vila-pinto.html";
        if (base.includes("cooadesc") || base.includes("coadesc") || base.includes("crgr_cooadesc") || base.includes("crgr_coadesc")) return "cooadesc.html";
        if (base.includes("padre") || base.includes("cacique") || base.includes("crgr_padre_cacique") || base.includes("padre-cacique")) return "padre-cacique.html";
        return "#";
    }
    function getCrgrColor(item = {}, index = 0) {
        if (item.color) return item.color;
        const base = `${item.name || ""} ${item.id || ""} ${item.territoryId || ""}`.toLowerCase();
        if (base.includes("vila")) return "#62B32F";
        if (base.includes("cooadesc") || base.includes("coadesc")) return "#2FA8D8";
        if (base.includes("padre") || base.includes("cacique")) return "#ef6b22";
        const colors = [
            "#62B32F",
            "#2FA8D8",
            "#ef6b22"
        ];
        return colors[index % colors.length];
    }
    function normalizeCrgrDocs(raw = []) {
        return raw.map((item, index)=>{
            const territoryId = canonicalTerritoryId(item.territoryId || item.code || item.id);
            const name = item.name || item.title || item.label || item.territoryLabel || item.cooperativaNome || item.code || item.id || "CRGR";
            const id = item.id || item.code || territoryId || name;
            return {
                id: id,
                code: item.code || item.id || territoryId,
                territoryId: territoryId,
                name: name,
                territoryLabel: item.territoryLabel || item.name || item.title || item.label || item.cooperativaNome || item.code || item.id || "CRGR",
                lat: toNumberOrNull(item.lat ?? item.latitude ?? item.coords?.lat ?? item.location?.lat),
                lng: toNumberOrNull(item.lng ?? item.longitude ?? item.coords?.lng ?? item.location?.lng),
                address: item.address || item.enderecoCompleto || item.location?.address || item.endereco || "",
                page: item.page || item.link || item.slug || getCrgrPage(name, id, territoryId),
                active: item.active ?? String(item.status || "").toLowerCase() === "active",
                color: item.color || getCrgrColor({
                    name: name,
                    id: id,
                    territoryId: territoryId
                }, index)
            };
        }).filter((item)=>item.id);
    }
    function renderMetrics(metrics = {}) {
        setText("metricCrgrs", metrics.crgrs || 0);
        setText("metricUsers", metrics.users || 0);
        setText("metricApprovals", metrics.approvals || 0);
        setText("metricColetas", metrics.coletas || 0);
        setText("metricAlerts", metrics.alerts || 0);
    }
    function createCrgrIcon(color = "#62B32F") {
        return window.L.divIcon({
            className: "crgr-map-marker",
            html: `
        <span
          style="
            --marker-color:${escapeHtml(color)};
            display:block;
            width:24px;
            height:24px;
            border-radius:999px;
            background:${escapeHtml(color)};
            border:4px solid #ffffff;
            box-shadow:0 8px 18px rgba(0,0,0,.28);
          "
        ></span>
      `,
            iconSize: [
                24,
                24
            ],
            iconAnchor: [
                12,
                12
            ],
            popupAnchor: [
                0,
                -14
            ]
        });
    }
    function createCrgrPopup(item = {}, index = 0) {
        const name = escapeHtml(item.name || item.territoryLabel || "CRGR");
        const address = escapeHtml(item.address || "Territ\xf3rio conectado \xe0 plataforma");
        const page = item.page || getCrgrPage(item.name, item.id, item.territoryId);
        const color = escapeHtml(getCrgrColor(item, index));
        return `
      <div class="crgr-popup" style="min-width:220px; font-family:'Inter',sans-serif;">
        <div style="display:flex; gap:8px; align-items:center; margin-bottom:8px;">
          <span style="width:12px; height:12px; border-radius:999px; background:${color}; display:inline-block;"></span>
          <strong style="font-family:'Archivo Condensed',sans-serif; font-size:20px; line-height:1;">
            ${name}
          </strong>
        </div>

        <div style="font-size:13.5px; line-height:1.45; color:#4f5558; margin-bottom:12px;">
          ${address}
        </div>

        ${page && page !== "#" ? `
              <a
                href="${escapeHtml(page)}"
                class="small-btn solid"
                style="
                  display:inline-flex;
                  align-items:center;
                  justify-content:center;
                  min-height:36px;
                  padding:8px 12px;
                  border-radius:999px;
                  background:${color};
                  color:#ffffff;
                  text-decoration:none;
                  font-size:13px;
                  font-weight:800;
                "
              >
                Acessar cooperativa \u{2192}
              </a>
            ` : ""}
      </div>
    `;
    }
    function initMap() {
        const mapEl = byId("map");
        if (!mapEl || typeof window.L === "undefined") return null;
        if (!map) {
            const isMobile = window.matchMedia("(max-width: 768px)").matches;
            map = window.L.map(mapEl, {
                zoomControl: true,
                scrollWheelZoom: false,
                dragging: !isMobile,
                touchZoom: false,
                doubleClickZoom: false,
                boxZoom: false,
                keyboard: false,
                tap: false
            }).setView([
                INITIAL_MAP_VIEW.lat,
                INITIAL_MAP_VIEW.lng
            ], INITIAL_MAP_VIEW.zoom);
            window.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                attribution: "&copy; OpenStreetMap",
                maxZoom: 19
            }).addTo(map);
        }
        return map;
    }
    function renderMap(crgrs = []) {
        const mapInstance = initMap();
        if (!mapInstance) return;
        mapMarkers.forEach((marker)=>{
            mapInstance.removeLayer(marker);
        });
        mapMarkers = [];
        const validPoints = getValidCrgrs(crgrs);
        if (!validPoints.length) {
            mapInstance.setView([
                INITIAL_MAP_VIEW.lat,
                INITIAL_MAP_VIEW.lng
            ], INITIAL_MAP_VIEW.zoom);
            return;
        }
        const bounds = [];
        validPoints.forEach((item, index)=>{
            const marker = window.L.marker([
                item.lat,
                item.lng
            ], {
                icon: createCrgrIcon(getCrgrColor(item, index)),
                title: item.name || item.territoryLabel || "CRGR"
            }).addTo(mapInstance);
            marker.bindPopup(createCrgrPopup(item, index), {
                closeButton: true,
                maxWidth: 280,
                className: "crgr-leaflet-popup"
            });
            mapMarkers.push(marker);
            bounds.push([
                item.lat,
                item.lng
            ]);
        });
        if (bounds.length === 1) mapInstance.setView(bounds[0], 14);
        else mapInstance.fitBounds(bounds, {
            padding: [
                38,
                38
            ],
            maxZoom: 13
        });
        setTimeout(()=>{
            mapInstance.invalidateSize();
        }, 250);
    }
    async function loadCollectionSafe(dbInstance, name) {
        try {
            const snap = await (0, $ilpIi.getDocs)((0, $ilpIi.query)((0, $ilpIi.collection)(dbInstance, name), (0, $ilpIi.orderBy)("createdAt", "desc")));
            return snap.docs.map((docItem)=>({
                    id: docItem.id,
                    ...docItem.data()
                }));
        } catch  {
            try {
                const snap = await (0, $ilpIi.getDocs)((0, $ilpIi.collection)(dbInstance, name));
                return snap.docs.map((docItem)=>({
                        id: docItem.id,
                        ...docItem.data()
                    }));
            } catch (error) {
                console.warn(`[INDEX] N\xe3o foi poss\xedvel ler ${name}:`, error);
                return [];
            }
        }
    }
    async function loadCollectionFromAllDatabases(name) {
        const results = await Promise.all(FIREBASE_DATABASES.map(async (source)=>{
            const items = await loadCollectionSafe(source.db, name);
            return items.map((item)=>({
                    ...item,
                    __sourceDb: source.key,
                    __sourceLabel: source.label
                }));
        }));
        return results.flat();
    }
    async function loadCRGRCollections() {
        try {
            const [territories, cooperativas, crgrs] = await Promise.all([
                loadCollectionFromAllDatabases("territories"),
                loadCollectionFromAllDatabases("cooperativas"),
                loadCollectionFromAllDatabases("crgrs")
            ]);
            const normalized = normalizeCrgrDocs([
                ...territories,
                ...cooperativas,
                ...crgrs
            ]);
            const validNormalized = getValidCrgrs(normalized);
            STATE.crgrs = validNormalized.length ? validNormalized : FALLBACK_CRGRS;
            renderMap(STATE.crgrs);
        } catch (error) {
            console.error("[INDEX] Erro ao carregar CRGRs:", error);
            STATE.crgrs = FALLBACK_CRGRS;
            renderMap(STATE.crgrs);
        }
    }
    function getCollectionCount(items = []) {
        return Array.isArray(items) ? items.length : 0;
    }
    function isPendingApproval(item = {}) {
        const status = String(item.status || item.decision || item.approvalStatus || "").trim().toLowerCase();
        return [
            "pending",
            "pendente",
            "waiting",
            "aguardando"
        ].includes(status);
    }
    async function computeIndicatorsDirectlyFromCollections() {
        const [participants, coletas, approvals, alerts] = await Promise.all([
            loadCollectionFromAllDatabases("participants"),
            loadCollectionFromAllDatabases("coletas"),
            loadCollectionFromAllDatabases("approvalRequests"),
            loadCollectionFromAllDatabases("alerts")
        ]);
        return {
            users: getCollectionCount(participants),
            coletas: getCollectionCount(coletas),
            approvals: approvals.filter(isPendingApproval).length || getCollectionCount(approvals),
            alerts: getCollectionCount(alerts),
            crgrs: 3
        };
    }
    function clearPublicIndicatorsListeners() {
        publicIndicatorsUnsubscribers.forEach((unsubscribe)=>{
            try {
                unsubscribe();
            } catch (_) {}
        });
        publicIndicatorsUnsubscribers = [];
    }
    async function loadPublicIndicators() {
        clearPublicIndicatorsListeners();
        const totalsByDatabase = new Map();
        function recomputeTotalsFromSummaries() {
            let users = 0;
            let coletas = 0;
            let approvals = 0;
            let alerts = 0;
            const activeCrgrs = new Set();
            totalsByDatabase.forEach((summaries)=>{
                summaries.forEach((item)=>{
                    const territoryId = canonicalTerritoryId(item.territoryId || item.id || item.code);
                    if (!isValidCrgrId(territoryId)) return;
                    activeCrgrs.add(territoryId);
                    users += Number(item.usersCount ?? item.participantsCount ?? 0);
                    coletas += Number(item.coletasCount ?? 0);
                    approvals += Number(item.approvalsCount ?? 0);
                    alerts += Number(item.alertsCount ?? 0);
                });
            });
            STATE.metrics = {
                users: users,
                coletas: coletas,
                approvals: approvals,
                alerts: alerts,
                crgrs: Math.min(activeCrgrs.size || 3, 3)
            };
            renderMetrics(STATE.metrics);
        }
        let hasAtLeastOnePublicDashboard = false;
        FIREBASE_DATABASES.forEach((source)=>{
            try {
                const publicCollectionRef = (0, $ilpIi.collection)(source.db, "dashboard_public_by_cooperativa");
                const unsubscribe = (0, $ilpIi.onSnapshot)(publicCollectionRef, (snapshot)=>{
                    const summaries = snapshot.docs.map((docItem)=>({
                            id: docItem.id,
                            ...docItem.data(),
                            __sourceDb: source.key,
                            __sourceLabel: source.label
                        }));
                    if (summaries.length) hasAtLeastOnePublicDashboard = true;
                    totalsByDatabase.set(source.key, summaries);
                    recomputeTotalsFromSummaries();
                }, async (snapshotError)=>{
                    console.warn(`[INDEX] Falha no onSnapshot dos indicadores p\xfablicos (${source.label}):`, snapshotError);
                    try {
                        const snap = await (0, $ilpIi.getDocs)(publicCollectionRef);
                        const summaries = snap.docs.map((docItem)=>({
                                id: docItem.id,
                                ...docItem.data(),
                                __sourceDb: source.key,
                                __sourceLabel: source.label
                            }));
                        if (summaries.length) hasAtLeastOnePublicDashboard = true;
                        totalsByDatabase.set(source.key, summaries);
                        recomputeTotalsFromSummaries();
                    } catch (fallbackError) {
                        console.warn(`[INDEX] Erro ao carregar indicadores p\xfablicos (${source.label}):`, fallbackError);
                        totalsByDatabase.set(source.key, []);
                        recomputeTotalsFromSummaries();
                    }
                });
                publicIndicatorsUnsubscribers.push(unsubscribe);
            } catch (error) {
                console.warn(`[INDEX] N\xe3o foi poss\xedvel iniciar indicadores de ${source.label}:`, error);
                totalsByDatabase.set(source.key, []);
            }
        });
        setTimeout(async ()=>{
            const currentHasValues = Number(STATE.metrics.users || 0) > 0 || Number(STATE.metrics.coletas || 0) > 0 || Number(STATE.metrics.approvals || 0) > 0 || Number(STATE.metrics.alerts || 0) > 0;
            if (hasAtLeastOnePublicDashboard && currentHasValues) return;
            try {
                const directMetrics = await computeIndicatorsDirectlyFromCollections();
                STATE.metrics = directMetrics;
                renderMetrics(STATE.metrics);
            } catch (error) {
                console.error("[INDEX] Erro ao calcular indicadores diretamente:", error);
                renderMetrics({
                    users: 0,
                    coletas: 0,
                    approvals: 0,
                    crgrs: FALLBACK_CRGRS.length,
                    alerts: 0
                });
            }
        }, 1500);
    }
    function initHashScroll() {
        if (!window.location.hash) return;
        const target = document.querySelector(window.location.hash);
        if (!target) return;
        setTimeout(()=>{
            safeScrollTo(target);
        }, 100);
    }
    initCursorGlow();
    initReveal();
    initAnchorScroll();
    initFaq();
    initHeroCarousel();
    initHashScroll();
    renderMetrics(STATE.metrics);
    renderMap(FALLBACK_CRGRS);
    Promise.all([
        loadCRGRCollections(),
        loadPublicIndicators()
    ]).catch((error)=>{
        console.error("[INDEX] Falha geral ao iniciar index:", error);
    });
});


//# sourceMappingURL=hub-resiliencia-em-rede.4e10c2d9.js.map
